import API from './Api';

class SchoolsubjectAPI extends API {
  constructor() {
    super('/schoolsubjects');
  }

}

export default SchoolsubjectAPI;